// extracted by mini-css-extract-plugin
module.exports = {"infoSecure":"InformationSecure_infoSecure__QIlsS"};